require('./main/script');
require('./swipers/swipers');
require('./wow/wow');
require('./lightbox/lightbox');
